import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callPost } from "../../http_client";

import { requestFailure, requestSuccess, sendRequest } from "./actions";
import { ContactActionTypes } from "./types";

export function* handleSendRequest(action: ReturnType<typeof sendRequest>): SagaIterator {
  try {
    const res = yield call(callPost, "/contact/", action.payload);
    if (res.data.error) {
      yield put(requestFailure(res.data.error));
    } else {
      yield put(requestSuccess());
    }
  } catch (err) {
    yield put(requestFailure(err.message));
  }
}

function* watchContactPageSagas(): SagaIterator {
  yield takeLatest(ContactActionTypes.SEND_REQUEST, handleSendRequest);
}

export default watchContactPageSagas;
